(function ($) {
  $(document).ready(function () {
    let validateAPI = false;

    if ($('#recover-password-section').length) {

      $("title").text('Quên Mật Khẩu');
      $(window).keydown(function(event){
        if(event.keyCode == 13) {
          event.preventDefault();
          return false;
        }
      });
      recoverPassword();
    }

    function recoverPassword() {
      $('.submit-form-recover').on('click', function () {
        let eleThis = this;
        $('.alert--error').remove();
        let valEmail = $('.form-recover').find('[name="email"]').val().trim();
        if (!valEmail || !validateEmailRegex(valEmail)) {
          let err_html = `<div class="alert alert--error"><span class="alert__title">Có một số  lỗi xảy ra</span><ul class="alert__errors"><li class="alert__error">Email không hợp lệ</li></ul></div>`;
          $(err_html).insertBefore($(".form-recover .form__control"));
        } else {
          
        // var token = $('textarea[name="g-recaptcha-response"]').val();
        // Intergrate GG Recaptcha V3
        grecaptcha.ready(function() {
          grecaptcha.execute(window.ggrecaptcha.site_key, {action: 'submit'}).then(function(token) {
            if (token == undefined || token == null || token == '') {
              let err_html = `<div class="alert alert--error"><span class="alert__title">Có một số lỗi xảy ra</span><ul class="alert__errors"><li class="alert__error">Vui lòng kiểm tra reCAPTCHA</li></ul></div>`;
              $(err_html).insertBefore($(".form-recover .form__control"));
              return false;
            }
            else {
              $('.alert--error').remove();
            }
              
            let data = { "email": valEmail, "reCAPTCHA": token };
            if ($('.loader-forgot-password').length) {
              $('.loader-forgot-password').show();
            } else {
              $(".form-recover .button-wrapper").append('<span class="loader-forgot-password"></span>');
            }
            $(eleThis).hide();
            callAPIWithTokenRefresh('customers/validate_email', 'post', data)
              .then(function (res) {
                $(eleThis).show();
                $('.loader-forgot-password').hide();
                validateAPI = res.status;
                if (res.status) {
                  $(".form-recover").submit();
                } else {
                  let err_html = `<div class="alert alert--error"><span class="alert__title">Có một số  lỗi xảy ra</span><ul class="alert__errors"><li class="alert__error">Không tìm thấy tài khoản với email đó.</li></ul></div>`;
                  $(err_html).insertBefore($(".form-recover .form__control"));
                }
              });
            });
          });
        }
      })
    }

    function forgotPassword() {
      if ($('#recover-password-section').length) {
        validateEmail($('#recover-password-section'));
      }
    }

    function validateEmail(ele) {
      $('#btnRecover').on('click', function () {
        let valEmail = $(ele).find('[name="email"]').val().trim();
        if (!valEmail) {
          $('.error').remove();
          $(ele).find('[name="email"]').parent().append('<span class="error error-forgot-pass">Trường này là bắt buộc.</span>');
        } else {
          let data = { "email": valEmail }
          callAPIWithTokenRefresh('customers/validate_email', 'post', data)
            .then(function (res) {
              console.log(res);
              if (!res.status) {
                $('.error').remove();
                $(ele).find('[name="email"]').parent().append('<span class="error error-forgot-pass">Không tìm thấy tài khoản nào với email này.</span>');
              }
            });
        }

      })
    }

    function validateEmailRegex(email) {
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  })
}(jQuery));
